const data = {
  hostUrl: "www.makeofferapp.com",
  protocol: "https",
  environment: "production"
}

export default data
